export default __webpack_public_path__ + "static/media/D7 - Senior Citizens.3361ae02.jpg";